export const UTM_TRACKING_STORE_NAME = 'utm-tracking-store';
